import { useEffect, useRef, useState } from 'react'
import { PlusSquare } from 'react-bootstrap-icons'

export default function SearchComponent({ name, details, onsBeforeSearch, onAfterSearch, onSelected, placeholder, response, defaultValue, focusSearch }) {
    const containerRef = useRef()
    const resultsRef = useRef()
    const searchRef = useRef()
    const [isOpen, setIsOpen] = useState(false)
    const [results, setResults] = useState([])
    const [result, setResult] = useState([])
    const [highlightedIndex, setHighlightedIndex] = useState(-1)
    // const highlightedIndexRef = useRef(0)
    const [options, setOptions] = useState(typeof details === 'undefined' ? {
        data: [{ id: 1, name: 'tom', surname: 'harry' }],
        options: {
            reRefKey: 'id',
            template: [{
                refKey: 'name',
                descr: '',
            }]
        }
    } : details)

    // useClickOutside(containerRef, (() => { setIsOpen(false); setResult() }))

    useEffect(() => {
        setOptions(details)
        // if (results.length === 0)
        //   setResults(options.data)
    }, [details])

    /// Add Keyboard Events
    useEffect(() => {
        const _handleKeyboardEvents = (e) => {
            switch (e.key) {
                case 'Escape': setResult(); setIsOpen(false); break;
                case 'ArrowDown': setHighlightedIndex((highlightedIndex) => highlightedIndex < results.length - 1 ? highlightedIndex + 1 : results.length - 1); break;
                case 'ArrowUp': setHighlightedIndex((highlightedIndex) => highlightedIndex > 0 ? highlightedIndex - 1 : 0); break;
                case 'Enter':
                    _handleSetSelected(results[highlightedIndex][options.options['reRefKey']], results[highlightedIndex]);
                    break;
                default: break;
            }
        }

        if (isOpen && results)
            document.addEventListener('keydown', _handleKeyboardEvents);
        else
            document.removeEventListener('keydown', _handleKeyboardEvents);
        return () => {
            document.removeEventListener('keydown', _handleKeyboardEvents);
        };
    }, [isOpen, results, highlightedIndex])

    const _renderDefault = () => {
        if (defaultValue)
            for (const item of options.data) {
                if (item[options.options.reRefKey] === defaultValue[options.options.reRefKey]) {
                    var entries =
                        options.options.template
                            .map((t) => { return item[t.refKey] })
                    if (entries)
                        resultsRef.current.value = entries.join(' ')
                }
            }
        else resultsRef.current.value = null
    }

    useEffect(() => {
        // if (results.length === 0)
        setResults(options.data)
        _renderDefault()
    }, [options])
    useEffect(() => {
        // if (results.length === 0)
        _renderDefault()
        // setResults(options.data)
    }, [defaultValue])
    /*
      Handle Events
    */

    // Lightweight fuzzy scoring helper. Returns a higher score for better matches (0-100).
    const _fuzzyScore = (query, target) => {
        if (!query || !target) return 0
        query = ("" + query).toLowerCase().trim()
        target = ("" + target).toLowerCase().trim()
        if (query === '' || target === '') return 0

        // Direct substring match is strong => bonus based on start position and length
        const idx = target.indexOf(query)
        if (idx !== -1) {
            const substringScore = 100 - idx + (query.length / target.length) * 20
            return Math.min(substringScore, 100)
        }

        // Sequential character match (all characters in order)
        let qi = 0, ti = 0, start = -1, end = -1
        while (ti < target.length && qi < query.length) {
            if (target[ti] === query[qi]) {
                if (start === -1) start = ti
                end = ti
                qi++
            }
            ti++
        }
        if (qi !== query.length) return 0

        const span = end - start + 1 || 1
        let score = 50 + (query.length / target.length) * 30 + (query.length / span) * 20
        // Bonus when match begins at a word start
        if (start === 0 || target[start - 1] === ' ') score += 10
        return Math.min(score, 100)
    }

    const _handleSearch = (search) => {
        // Empty search shows all results
        if (!search || search === '') return setResults(options.data)

        const q = search.toLowerCase().trim()
        const hits = []

        // Choose which keys to search: template keys if available, otherwise all string keys on the object
        const searchKeys = options && options.options && options.options.template && options.options.template.length > 0 ? options.options.template.map(t => t.refKey) : null

        for (const item of options.data) {
            let best = 0
            if (searchKeys) {
                for (const k of searchKeys) {
                    try {
                        const val = item[k]
                        if (!val) continue
                        const s = _fuzzyScore(q, val + '')
                        if (s > best) best = s
                    } catch (e) { }
                }
            } else {
                // Fallback: search all string values on the item
                for (const k of Object.keys(item)) {
                    try {
                        const val = item[k]
                        if (!val || typeof val !== 'string') continue
                        const s = _fuzzyScore(q, val)
                        if (s > best) best = s
                    } catch (e) { }
                }
            }
            if (best > 0) hits.push({ item, score: best })
        }

        // Sort by score (descending) then by label (stable)
        hits.sort((a, b) => b.score - a.score)

        const sorted = hits.map(h => h.item)
        setResults(sorted)
        setHighlightedIndex(sorted.length > 0 ? 0 : -1)
    }

    // Toggle component open/close
    const _handleResultsClick = () => {
        if (focusSearch)
            setTimeout(() => { searchRef.current.select() }, 300)

        setIsOpen(true)
        resultsRef.current.blur()
    }

    // Handle selected
    const _handleSetSelected = (res_id, _result) => {
        setResult(_result)
        if (options.options.returns === 'object' && onSelected)
            onSelected(_result)
        else if (onSelected) onSelected(res_id)

        var dtls = options.options.template
            .map((t) => { return _result[t.refKey] + "" })
        resultsRef.current.value = dtls.join(' ')

        setIsOpen(false)
    }
    /*
      Render line item
    */

    const _renderResultItem = (r, i) => {
        const res_id = r[options.options['reRefKey']];
        if (!res_id) throw Error('Invalid reRefKey set in options');
        if (!options.options.template) throw Error('No template specified in options');
        const _node_value = options.options.template
            .map((t, i) => <span key={`Search-Item-Result-${i}-${r[options.options['reRefKey']]}-${i}`}>{t.descr ? <b>{t.descr}</b> : <></>} {r[t.refKey]}</span>);
        return (
            <li
                key={`Search-Item-Result-li-${i}-${r[options.options['reRefKey']]}`}
                className={`m-1 p-1  ${i === highlightedIndex && 'bg-secondary-container'}`}
                onMouseDown={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    _handleSetSelected(res_id, r);
                }}
            >
                {_node_value}
            </li>
        );
    }
    const _renderAdd = () => {
        if (!options.options.onAdd) return
        return options.options.onAdd ? <li key='Render-LI' className={`m-1 p-1 d-flex align-items-center`} onClick={() => options.options.onAdd.action(searchRef.current.value)}><PlusSquare className='me-1' />{options.options.onAdd.text ? options.options.onAdd.text : 'Add New'}</li> : undefined
    }

    // This will activate the dropdown when a user clicks on it
    // or uses the keyboard navigation like using Tab
    const _handleComponentFocus = (e) => {
        if (isOpen) return
        _handleResultsClick()
    }

    const _handleUnfocus = (e) => {
        if (e.relatedTarget != null && !e.currentTarget.contains(e.relatedTarget)) {
            setResult(); setIsOpen(false);
            return
        }
    }

    return (
        <div name={name} ref={containerRef} onBlur={_handleUnfocus} className='position-relative'>
            <input onFocus={_handleComponentFocus} style={{ cursor: 'pointer' }} onClick={() => _handleResultsClick()} ref={resultsRef} className='form-control form-control-sm' placeholder={placeholder ? placeholder : ''} />
            <div className={'position-absolute p-3 bg-primary-container rounded shadow w-100 '.concat(isOpen ? 'd-block' : 'd-none')} style={{ zIndex: 999 }}>
                <input ref={searchRef} onChange={(e) => _handleSearch(e.target.value)} className='form-control form-control-sm' placeholder='Search' />
                <ul className='list-unstyled' style={{ maxHeight: '250px', overflow: 'auto', cursor: 'pointer' }}>
                    {_renderAdd()}
                    {results.map((res, index) => _renderResultItem(res, index))}
                </ul>
            </div>
        </div>
    )
}
